(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function slugify(text) {
    return text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function getHeaderOffset() {
    var header = document.getElementById('site-header');
    if (!header) return 0;
    var styles = window.getComputedStyle(header);
    // Include borders/shadows visually; offsetHeight should suffice
    return header.offsetHeight || parseInt(styles.height, 10) || 0;
  }

  function buildTOC() {
    var content = document.querySelector('.content');
    var tocCard = document.getElementById('toc-card');
    var tocList = document.getElementById('toc-list');

    if (!content || !tocCard || !tocList) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));

    if (!headings.length) {
      // Hide the card if no headings
      tocCard.style.display = 'none';
      return;
    }

    // Assign unique IDs
    var idCounts = Object.create(null);
    headings.forEach(function (h) {
      if (h.id) return; // keep existing IDs
      var base = slugify(h.textContent || h.innerText || 'section');
      var id = base;
      var i = 2;
      while (document.getElementById(id)) {
        id = base + '-' + i++;
      }
      // Also ensure per-page uniqueness against earlier headings
      if (idCounts[id]) {
        idCounts[id] += 1;
        id = id + '-' + idCounts[id];
      } else {
        idCounts[id] = 1;
      }
      h.id = id;
    });

    // Render list
    var frag = document.createDocumentFragment();
    headings.forEach(function (h) {
      var id = h.id;
      var text = h.textContent || h.innerText || id;
      var a = document.createElement('a');
      a.href = '#' + id;
      a.className = 'pl-4 block border-l border-transparent text-[#78716C] hover:text-[#1C1917] transition-colors';
      a.textContent = text;
      a.setAttribute('data-toc-link', id);
      frag.appendChild(a);
    });
    tocList.innerHTML = '';
    tocList.appendChild(frag);

    // Smooth scroll with header offset
    tocList.addEventListener('click', function (e) {
      var target = e.target;
      if (target && target.tagName === 'A' && target.hash) {
        var id = target.hash.slice(1);
        var el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        var headerOffset = getHeaderOffset() + 16; // small extra spacing
        var rect = el.getBoundingClientRect();
        var absoluteY = rect.top + window.pageYOffset;
        var scrollTo = Math.max(absoluteY - headerOffset, 0);
        window.history.replaceState(null, '', '#' + id);
        window.scrollTo({ top: scrollTo, behavior: 'smooth' });
      }
    });

    // Scrollspy using IntersectionObserver
    var observer;
    var activeId = null;
    var links = Array.prototype.slice.call(
      tocList.querySelectorAll('a[data-toc-link]')
    );

    function setActive(id) {
      if (id === activeId) return;
      activeId = id;
      links.forEach(function (lnk) {
        var isActive = lnk.getAttribute('data-toc-link') === id;
        if (isActive) {
          lnk.classList.add('font-medium');
          lnk.classList.add('text-[#1C1917]');
          lnk.classList.add('border-[#1C1917]');
          lnk.classList.remove('border-transparent');
          lnk.classList.remove('text-[#78716C]');
        } else {
          lnk.classList.remove('font-medium');
          lnk.classList.remove('text-[#1C1917]');
          lnk.classList.remove('border-[#1C1917]');
          lnk.classList.add('text-[#78716C]');
          lnk.classList.add('border-transparent');
        }
      });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          // Choose the most visible entry
          var visible = entries
            .filter(function (en) { return en.isIntersecting; })
            .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });
          if (visible.length) {
            setActive(visible[0].target.id);
          } else {
            // Fallback: pick the one closest to top
            var closest = headings.reduce(function (best, h) {
              var top = h.getBoundingClientRect().top;
              if (top < (getHeaderOffset() + 20)) return best; // already passed
              if (!best || top < best.top) return { id: h.id, top: top };
              return best;
            }, null);
            if (closest) setActive(closest.id);
          }
        },
        {
          root: null,
          rootMargin: '-' + (getHeaderOffset() + 8) + 'px 0px -60% 0px',
          threshold: [0, 0.25, 0.5, 0.75, 1],
        }
      );

      headings.forEach(function (h) { observer.observe(h); });
    } else {
      // Simple fallback on scroll
      function onScroll() {
        var headerOffset = getHeaderOffset() + 20;
        var current = headings[0] && headings[0].id;
        for (var i = 0; i < headings.length; i++) {
          var rect = headings[i].getBoundingClientRect();
          if (rect.top - headerOffset <= 0) current = headings[i].id;
          else break;
        }
        if (current) setActive(current);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  ready(buildTOC);
})();
